import styled from "styled-components";

export const Backdrop = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(20, 26, 38, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
`;

export const Card = styled.div`
    background: #FFFFFF;
    border-radius: 14px;
    padding: 22px;
    width: 100%;
    max-width: 420px;
    box-shadow: 0 12px 40px rgba(20, 26, 38, 0.22);
    font-family: Mulish;
`;

export const BackBtn = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    border: none;
    background: transparent;
    color: #6B7280;
    font-family: Mulish;
    font-size: 0.82rem;
    font-weight: 700;
    cursor: pointer;
    padding: 0;
    margin-bottom: 10px;
`;

export const Title = styled.h3`
    margin: 0 0 6px;
    font-size: 1.05rem;
    font-weight: 800;
    color: #2B3240;
`;

export const Hint = styled.p`
    margin: 0 0 12px;
    font-size: 0.8rem;
    color: #6B7280;
`;

export const Area = styled.textarea`
    width: 100%;
    min-height: 130px;
    resize: vertical;
    border: 1px solid #E3E8F0;
    border-radius: 10px;
    padding: 10px 12px;
    font-family: Mulish;
    font-size: 0.9rem;
    color: #2B3240;
    &:focus { outline: none; border-color: #2F80ED; }
`;

export const Count = styled.div`
    margin: 8px 0 16px;
    font-size: 0.8rem;
    color: #384250;
    font-weight: 700;
`;

// Aviso anti-ban (amarelo) — adicionar muita gente de uma vez pode banir o número.
export const Warn = styled.p`
    margin: 12px 0 0;
    padding: 8px 12px;
    border-radius: 8px;
    background: #FFF7E6;
    border: 1px solid #FFE1A8;
    color: #8A6D3B;
    font-size: 0.74rem;
    line-height: 1.4;
`;

export const Actions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 18px;
`;

export const CancelBtn = styled.button`
    border: none;
    background: #EEF1F6;
    color: #384250;
    font-family: Mulish;
    font-size: 0.85rem;
    font-weight: 700;
    padding: 9px 18px;
    border-radius: 8px;
    cursor: pointer;
`;

export const AddBtn = styled.button`
    border: none;
    background: #2F80ED;
    color: #FFFFFF;
    font-family: Mulish;
    font-size: 0.85rem;
    font-weight: 700;
    padding: 9px 18px;
    border-radius: 8px;
    cursor: pointer;
    &:disabled { opacity: 0.5; cursor: not-allowed; }
`;
